export function getContentBytes(content: string) {
  const byteCharacters = atob(content)
  const sliceSize = 512
  const byteArrays = []
  let offset, slice, byteNumbers, i, byteArray

  for (offset = 0; offset < byteCharacters.length; offset += sliceSize) {
    slice = byteCharacters.slice(offset, offset + sliceSize)
    byteNumbers = new Array(slice.length)
    for (i = 0; i < slice.length; i++) {
      byteNumbers[i] = slice.charCodeAt(i)
    }
    byteArray = new Uint8Array(byteNumbers)
    byteArrays.push(byteArray)
  }

  return byteArrays
}

export function normalizeContentType(contentType: string) {
  if (contentType.endsWith('wave')) {
    return 'audio/wav'
  }

  return contentType
}
